<script lang="ts">
  import { storyblokEditable, type SbBlokData } from '@storyblok/svelte';
  import type { CollageImageBlock } from '@storyblok-types';
  import { Image } from '@athena-lib/Image';
  import clsx from 'clsx';
  import { calculateFocalPoint } from '$lib/utilities/storyblok';

  const { blok }: { blok: CollageImageBlock & SbBlokData } = $props();
  const focalPoint = $derived(blok.image ? calculateFocalPoint(blok.image) : undefined);
</script>

{#if blok.image?.filename}
  <Image
    action={storyblokEditable}
    actionArg={blok}
    imgClass={clsx(
      focalPoint === 'center' && 'object-center',
      focalPoint === 'left' && 'object-left',
      focalPoint === 'right' && 'object-right',
      'h-full w-full object-cover',
    )}
    loading="lazy"
    src={blok.image.filename}
    alt={blok.image.alt ?? ''}
  />
{/if}
